import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import '@/locales'
import '@/styles/global.less'
import '@/styles/class.less'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
